import React, { useState, useContext, useEffect } from "react";
import axios from "../../helper/axios";
import { AuthContext } from "../../context/AuthContext";
import "./AddProducts.css";
import "./DashboardMain.css";
import DashSidebar from "./DashSidebar";
import { useLocation, NavLink } from "react-router-dom";

const UpdateJewelry = () => {
  const [products, setProducts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);

  const [productSku, setProductSku] = useState("");
  const [productName, setProductName] = useState("");
  const [image, setImage] = useState();
  const [carat, setCarat] = useState("");
  const [size, setSize] = useState("");
  const [getMetal, setMetal] = useState([]);
  const [getProductType, setProductType] = useState([]);
  const [getProductSetting, setProductSetting] = useState([]);
  const [getStyle, setStyle] = useState([]);
  const [getCollection, setCollection] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const { token } = useContext(AuthContext);
  const location = useLocation();

  // Add separate state variables to track the selected values
  const [selectedMetal, setSelectedMetal] = useState(
    getMetal.length > 0 ? getMetal[0].metal_id : ""
  );
  const [selectedProductType, setSelectedProductType] = useState(
    getProductType.length > 0 ? getProductType[0].product_type_id : ""
  );
  const [selectedProductSetting, setSelectedProductSetting] = useState(
    getProductSetting.length > 0 ? getProductSetting[0].product_settings_id : ""
  );
  const [selectedStyle, setSelectedStyle] = useState(
    getStyle.length > 0 ? getStyle[0].style_id : ""
  );
  const [selectedCollection, setSelectedCollection] = useState(
    getCollection.length > 0 ? getCollection[0].collection_id : "4"
  );

  // const [skuError, setSkuError] = useState("");

  // Determine the active class based on the current route
  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  useEffect(() => {
    const storedPage = localStorage.getItem("lastVisitedPage");
    if (storedPage) {
      setCurrentPage(parseInt(storedPage));
    }
    fetchProducts();
    fetchJeweleryData();
  }, [currentPage]);

  // useEffect(() => {}, [products]);

  const fetchProducts = async () => {
    const allData = {
      category: ["jewelry"],
      page: currentPage,
    };
    try {
      const response = await axios.post(`/product_read`, allData);
      const sortedProducts = response.data.data.sort(
        (a, b) =>
          new Date(a.product_created_on) - new Date(b.product_created_on)
      );
      setProducts(sortedProducts);
      setDataFetched(true);
      setTotalPages(response.data.total_pages);
    } catch (error) {
      console.error(error.response.data);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      // Store the current page in local storage
      localStorage.setItem("lastVisitedPage", currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
      // Store the current page in local storage
      localStorage.setItem("lastVisitedPage", currentPage + 1);
    }
  };

  const fetchJeweleryData = async () => {
    try {
      const metalData = await axios.get("/metal_read");
      const metalProduct = metalData.data.data;
      setMetal(metalProduct);

      const productTypeData = await axios.get("/product_type_read");
      const productTypeProduct = productTypeData.data.data;
      setProductType(productTypeProduct);

      const productSettingsData = await axios.get("/product_settings_read");
      const productSettingsProduct = productSettingsData.data.data;
      setProductSetting(productSettingsProduct);

      const StyleData = await axios.get("/style_read");
      const StyleProduct = StyleData.data.data;
      setStyle(StyleProduct);

      const CollectionData = await axios.get("/collection_read");
      const CollectionProduct = CollectionData.data.data;
      setCollection(CollectionProduct);
    } catch (error) {
      console.error(error.response.data.data);
    }
  };

  const ListMetal =
    getMetal.length > 0 ? (
      getMetal.map((metal) => (
        <option key={metal.metal_id} value={metal.metal_id}>
          {metal.metal_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListProductType =
    getProductType.length > 0 ? (
      getProductType.map((product_type) => (
        <option
          key={product_type.product_type_id}
          value={product_type.product_type_id}
        >
          {product_type.product_type_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListProductSetting =
    getProductSetting.length > 0 ? (
      getProductSetting.map((product_settings) => (
        <option
          key={product_settings.product_settings_id}
          value={product_settings.product_settings_id}
        >
          {product_settings.product_settings_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListStyle =
    getStyle.length > 0 ? (
      getStyle.map((style) => (
        <option key={style.style_id} value={style.style_id}>
          {style.style_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListCollection =
    getCollection.length > 0 ? (
      getCollection.map((collection) => (
        <option key={collection.collection_id} value={collection.collection_id}>
          {collection.collection_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const openEditModal = (productId) => {
    const product = products.find(
      (product) => product.product_id === productId
    );
    if (product) {
      setEditingProduct({ ...product });
      setModalOpen(true);
    } else {
      console.log("Product not found");
    }
  };

  const closeEditModal = () => {
    setEditingProduct(null);
    setModalOpen(false);
  };

  const handleSaveClick = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("carat", editingProduct.carat);
      formData.append("price", editingProduct.product_price);
      formData.append("product_sku", editingProduct.product_sku);

      // formData.append("product_image", editingProduct.product_image);
      for (let i = 0; i < editingProduct.length; i++) {
        formData.append("product_image", editingProduct.product_image[i]);
      }

      formData.append("product_name", editingProduct.product_name);
      formData.append("metal_id_fk", selectedMetal);
      formData.append("product_type_id_fk", selectedProductType);
      formData.append("settings_id_fk", selectedProductSetting);
      formData.append("style_id_fk", selectedStyle);
      formData.append("collection_id_fk", selectedCollection);

      formData.append("shape_id_fk", "14");
      formData.append("color_id_fk", "7");
      formData.append("clarity_id_fk", "8");
      formData.append("cut_id_fk", "6");
      formData.append("category_id_fk", "6");
      formData.append("stone_type", "0");
      formData.append("matching_band", "0");
      formData.append("in_stock", 1);

      // formData.append('product_image', editingProduct.product_image);
      // formData.append('shape', editingProduct.shape);
      // formData.append('carat', editingProduct.carat);
      // formData.append('color', editingProduct.color);
      // formData.append('cut', editingProduct.cut);
      // formData.append('price', editingProduct.price);\

      const response = await axios.put(
        `/product_update/${editingProduct.product_id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Product Updated Successfully!", response.data);
      // setIsProductUpdated(true);
      setModalOpen(false);

      setProducts((prevProducts) =>
        prevProducts.map((product) => {
          if (product.product_id === editingProduct.product_id) {
            return {
              ...product,
              ...editingProduct,
            };
          }
          return product;
        })
      );

      setEditingProduct(null);

      fetchProducts();
    } catch (error) {
      console.error(error.response.data);
      // alert("Update Failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const deleteProduct = async () => {
    // Check if any products are selected
    if (selectedProducts.length === 0) {
      alert("Please select products to delete.");
      return;
    }

    if (
      window.confirm("Are you sure you want to delete the selected products?")
    ) {
      setIsDeleting(true);
      try {
        const promises = selectedProducts.map((productId) =>
          axios.delete(`/product_delete/${productId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
        );

        await Promise.all(promises);

        setProducts((prevProducts) =>
          prevProducts.filter(
            (product) => !selectedProducts.includes(product.product_id)
          )
        );

        setSelectedProducts([]);
        alert("Selected Products Deleted Successfully!");
        fetchProducts();
      } catch (error) {
        console.error(error.response.data);
        // alert('Failed to delete products.');
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const handleCheckboxChange = (productId) => {
    if (selectedProducts.includes(productId)) {
      setSelectedProducts(selectedProducts.filter((id) => id !== productId));
    } else {
      setSelectedProducts([...selectedProducts, productId]);
    }
  };

  return (
    <>
      {dataFetched ? ( // Show the table only when the data is fetched
        <div className="">
          {/* <h3>Update Products</h3> */}

          <h5 className="mt-4 mb-3">{products.length} products available</h5>

          {products.length > 0 ? (
            <>
              <table className="product-table table">
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>Image</th>
                    <th>SKU</th>
                    <th>Product Name</th>
                    <th>Collection</th>
                    <th>Type</th>
                    <th>Metal</th>
                    <th>Setting</th>
                    <th>Size</th>
                    <th>Style</th>
                    <th>Carat</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((product, index) => (
                    <>
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedProducts.includes(
                              product.product_id
                            )}
                            onChange={() =>
                              handleCheckboxChange(product.product_id)
                            }
                          />
                        </td>
                        <td>
                          <NavLink to={`/singleproduct/${product.product_sku}`}>
                            <img
                              src={product.product_image[0]}
                              alt="Product img"
                              className="product-table-img"
                            />
                          </NavLink>
                        </td>
                        <td>
                          <NavLink
                            to={`/singleproduct/${product.product_sku}`}
                            className="link-dark fw-bold"
                          >
                            {product.product_sku}
                          </NavLink>
                        </td>
                        <td>{product.product_name}</td>
                        <td>{product.collection_name}</td>
                        <td>{product.product_type_name}</td>
                        <td>{product.metal_name}</td>
                        <td>{product.product_settings_name}</td>
                        <td>{product.size}</td>
                        <td>{product.style_name}</td>
                        <td>{product.carat}</td>
                        <td>{product.product_price}</td>
                        <td>
                          <span
                            className="action-icon edit-product"
                            onClick={() => openEditModal(product.product_id)}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </span>
                          <span
                            className="action-icon delete-products"
                            onClick={() => deleteProduct(product.product_id)}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>

              <div className="pagination mx-auto">
                <button
                  className="btn btn__primary"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <p className="page-number mx-2">{currentPage}</p>
                <button
                  className="btn btn__primary"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <p>No products available</p>
          )}
        </div>
      ) : (
        <p>Loading data...</p> // Show a loading message while the data is being fetched
      )}

      {modalOpen && editingProduct && (
        <div
          className="modal fade show product-modal"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Edit {editingProduct.product_name}
                </h5>
                <button
                  type="button"
                  className="close btn"
                  onClick={closeEditModal}
                  data-bs-dismiss="modal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSaveClick} className="py-3 m-0 w-100">
                  <div className="row">
                    <div className="col-sm-3 mb-4">
                      <label htmlFor="" className="form-label">
                        Select Type
                      </label>
                      <select
                        className="form-select"
                        aria-label="Type"
                        value={selectedProductType}
                        onChange={(e) => (
                          setSelectedProductType(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            product_type: e.target.value,
                          })
                        )}
                      >
                        {ListProductType}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Select Metal
                      </label>
                      <select
                        className="form-select"
                        aria-label="Shape"
                        value={selectedMetal}
                        onChange={(e) => (
                          setSelectedMetal(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            metal: e.target.value,
                          })
                        )}
                      >
                        {ListMetal}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Select Setting
                      </label>
                      <select
                        className="form-select"
                        aria-label="Color"
                        value={selectedProductSetting}
                        onChange={(e) => (
                          setSelectedProductSetting(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            product_settings: e.target.value,
                          })
                        )}
                      >
                        {ListProductSetting}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Select Style
                      </label>
                      <select
                        className="form-select"
                        aria-label="Style"
                        value={selectedStyle}
                        onChange={(e) => (
                          setSelectedStyle(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            style: e.target.value,
                          })
                        )}
                      >
                        {ListStyle}
                      </select>
                    </div>

                    <div className="col-sm-3 mb-4">
                      <label htmlFor="" className="form-label">
                        Collection
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        value={selectedCollection}
                        onChange={(e) => (
                          setSelectedCollection(e.target.value),
                          setEditingProduct({
                            ...editingProduct,
                            collection: e.target.value,
                          })
                        )}
                      >
                        {ListCollection}
                      </select>
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Size
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="size"
                        value={editingProduct.size}
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            size: e.target.value,
                          })
                        }
                        id=""
                        placeholder="Size"
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Carat
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="carat"
                        value={editingProduct.carat}
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            carat: e.target.value,
                          })
                        }
                        id=""
                        placeholder="Carat"
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Price
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="product_price"
                        value={editingProduct.product_price}
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            product_price: e.target.value,
                          })
                        }
                        id=""
                        placeholder="Price"
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="" className="form-label">
                        Products SKU
                      </label>
                      <input
                        type="text"
                        disabled
                        className="form-control"
                        name="product_sku"
                        value={editingProduct.product_sku}
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            product_sku: e.target.value,
                          })
                        }
                        id=""
                        placeholder="Product SKU"
                      />
                      {/* {skuError && <div className="mt-2 alert alert-danger">{skuError}</div>} */}
                    </div>

                    <div className="col-sm-6">
                      <label htmlFor="" className="form-label">
                        Product Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="product-name"
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            product_name: e.target.value,
                          })
                        }
                        id=""
                        placeholder="Product Name"
                      />
                    </div>

                    <div className="col-sm-12 my-4">
                      <label htmlFor="" className="form-label">
                        Products Images
                      </label>
                      <input
                        className="form-control m-0"
                        name="product_image"
                        accept="image/*"
                        type="file"
                        multiple
                        onChange={(e) =>
                          setEditingProduct({
                            ...editingProduct,
                            product_image: e.target.files,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="submit"
                      className="btn btn__primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save"}
                    </button>
                    <button
                      type="button"
                      className="btn btn__primary"
                      onClick={closeEditModal}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateJewelry;
